import React, { useState, useEffect } from 'react';
import { useAndroidDetection } from '../../hooks/useAndroidDetection';
import { websiteAnalytics, createTrackedPlayStoreUrl, TRACKING_CONFIGS } from '../../utils/analytics';
import './DownloadBanner.css';

const DownloadBanner: React.FC = () => {
  const isAndroid = useAndroidDetection();
  const [showBanner, setShowBanner] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Check if user has dismissed the banner before
    const bannerDismissed = localStorage.getItem('justfun-banner-dismissed');
    if (!bannerDismissed && isAndroid) {
      // Show banner after 3 seconds
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isAndroid]);

  const handleDismiss = () => {
    setShowBanner(false);
    setDismissed(true);
    localStorage.setItem('justfun-banner-dismissed', 'true');
  };

  const handleDownload = () => {
    // Track download click with analytics
    websiteAnalytics.trackDownloadClick(
      TRACKING_CONFIGS.WEBSITE_BANNER.source,
      TRACKING_CONFIGS.WEBSITE_BANNER.medium,
      TRACKING_CONFIGS.WEBSITE_BANNER.campaign
    );
    
    // Create UTM-tracked Play Store URL
    const playStoreUrl = createTrackedPlayStoreUrl(
      TRACKING_CONFIGS.WEBSITE_BANNER.source,
      TRACKING_CONFIGS.WEBSITE_BANNER.medium,
      TRACKING_CONFIGS.WEBSITE_BANNER.campaign,
      TRACKING_CONFIGS.WEBSITE_BANNER.content,
      TRACKING_CONFIGS.WEBSITE_BANNER.term
    );
    
    // Open Play Store with tracking
    window.open(playStoreUrl, '_blank');
  };

  if (!showBanner || dismissed) return null;

  return (
    <div className="download-banner">
      <div className="banner-content">
        <div className="banner-icon">📱</div>
        <div className="banner-text">
          <h3>🚀 Get the Full Experience!</h3>
          <p>Unlock rewards, achievements, and more games in the Android app</p>
          <div className="banner-features">
            <span>🏆 Rewards System</span>
            <span>📊 Analytics</span>
            <span>🎮 More Games</span>
            <span>📱 Offline Play</span>
          </div>
        </div>
        <div className="banner-actions">
          <button onClick={handleDownload} className="download-button">
            📥 Download App
          </button>
          <button onClick={handleDismiss} className="close-button">
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadBanner;
